import styled from 'styled-components';
import { WHITE } from "../../styles/colors";

type MerchantProfilePictureContainerProps = {
    $size?: number;
    $backgroundColor?: string;
    $borderColor?: string;
    $borderWidth?: number;
    $isClickable?: boolean;
}

export const Container = (styled.div<MerchantProfilePictureContainerProps>`
    width: ${({ $size = 36 }) => `${$size}px`};
    height: ${({ $size = 36 }) => `${$size}px`};
    border-radius: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ $backgroundColor }) => $backgroundColor || '#FFFFFF44'};
    border-width: ${({ $borderWidth = 1 }) => `${$borderWidth}px`};
    border-style: solid;
    border-color: ${({ $borderColor }) => $borderColor || WHITE};
    cursor: ${({ $isClickable }) => $isClickable ? 'pointer' : 'default'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ImageWrapper = (styled.div`
    width: 100%;
    height: 100%;
    border-radius: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ProfileImage = (styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Prevent image caching */
    &[src] {
        image-rendering: -webkit-optimize-contrast; /* Improves rendering in Chrome */
    }
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const EditIconContainer = (styled.div`
    position: absolute;
    bottom: 0px;
    right: 0px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
